import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
import { Stage, StageTypes } from './stage-codecs';
export var Admin = t.type({
  id: t.string,
  avatarUrl: nullable(t.string),
  name: t.string
});
export var ChallengeActivityTimelineEntry = t.type({
  typeCode: nullable(t.string),
  createdAt: nullable(t.string),
  message: nullable(t.string),
  iconUrl: nullable(t.string)
});
export var CorporateAlertStatus = t.keyof({
  ActivityTimelineCorporateRedo: null,
  ActivityTimelineCorporateConfirmation: null,
  ActivityTimelineReceivedFeedback: null,
  ActivityTimelineChallengeRejected: null
});
export var CorporateAlertEntries = t.intersection([ChallengeActivityTimelineEntry, t.type({
  __typename: CorporateAlertStatus,
  admin: nullable(Admin),
  feedback: nullable(t.string)
})]);
export var QuizTimelineTypenames = t.keyof({
  ActivityTimelineQuiz: null,
  ActivityTimelineQuizCorrect: null,
  ActivityTimelineQuizIncorrect: null
});
export var QuizTimelineEntries = t.intersection([ChallengeActivityTimelineEntry, t.type({
  __typename: QuizTimelineTypenames,
  stage: nullable(t.type({
    __typename: t.literal(StageTypes.map.QuizStage),
    id: t.string
  }))
})]);
export var StageInfo = t.intersection([t.type({
  __typename: StageTypes,
  id: t.string,
  position: t.number
}), t.partial({
  responsesArePublic: t["boolean"],
  publicResponses: nullable(t.type({
    totalCount: t.number
  }))
})]);
export var StageCompletion = t.type({
  stage: StageInfo
});
export var ActivityState = t.keyof({
  pending_auto_result: null,
  negative_auto_result: null,
  rejected: null,
  closed: null,
  active: null,
  corporate_confirmation: null,
  pending_confirmation: null,
  dismissed: null
});
export var Activity = t.type({
  id: t.string,
  currentStage: nullable(Stage),
  state: ActivityState,
  timeline: nullable(t.array(t.union([ChallengeActivityTimelineEntry, CorporateAlertEntries, QuizTimelineEntries]))),
  pointsEarned: nullable(t.number),
  stageCompletions: nullable(t.array(StageCompletion))
}, 'Activity');
var Prospect = t.type({
  name: t.string,
  title: nullable(t.string),
  company: nullable(t.string)
});
var BaseChallenge = t.type({
  __typename: t.literal('Challenge'),
  id: t.string,
  headline: t.string,
  description: nullable(t.string),
  banner: nullable(t.intersection([t.type({
    id: t.string,
    blurhash: t.string
  }), t.partial({
    url: t.string
  })])),
  totalStages: t.number,
  inProgress: t["boolean"],
  multiComplete: t["boolean"],
  unseen: t["boolean"],
  savedForLater: t["boolean"],
  availableForCompletion: t["boolean"],
  remainingCompletionCount: nullable(t.number),
  memberRemainingCompletionCount: nullable(t.number)
});
export var Challenge = t.intersection([BaseChallenge, t.type({
  firstStage: Stage,
  activities: nullable(t.array(Activity)),
  hideBannerImage: t["boolean"],
  prospect: nullable(Prospect)
})], 'Challenge');
export var ChallengeCardActivity = t.type({
  id: t.string,
  state: ActivityState,
  currentStage: nullable(t.type({
    position: t.number
  }))
});
export var ChallengeCard = t.intersection([BaseChallenge, t.type({
  activities: nullable(t.array(ChallengeCardActivity)),
  category: nullable(t.type({
    id: t.string,
    name: t.string
  })),
  minimumAvailablePoints: t.number,
  maximumAvailablePoints: t.number,
  expiresAt: nullable(t.string)
})]);